import {useEffect, useState} from 'react';
import Alert from '../../components/layout/Alert';
import Input from '../../components/form/Input';
import Spinner from '../../components/button/Spinner';
import {useNavigate} from 'react-router-dom';
import Tooltip from '../../components/layout/Tooltip';
import api from '../../services/api';

const inputsNoRepeat = [
    {
        label: 'ERP - CODIGO',
        name: 'cliente'
    }
];

const inputs = [
    {
        label: 'Emissao',
        name: 'emissao',
    }, {
        label: 'Loja',
        name: 'loja'
    },
    {
        label: 'Vencimento',
        name: 'vencimento'
    },
    {
        label: 'Valor',
        name: 'valor',
    }, {
        label: 'Parcela',
        name: 'parcela'
    }, {
        label: 'Prefixo',
        name: 'prefixo'
    }, {
        label: 'Tipo',
        name: 'tipo'
    }, {
        label: 'Contrato',
        name: 'contrato'
    }, {
        label: 'Numero',
        name: 'numero'
    }
]

export default function UserForm() {

    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [billet, setBillet] = useState([]);
    const [loading, setLoading] = useState(false);
    const user = JSON.parse(sessionStorage.getItem('user'));
    const navigate = useNavigate();

    const handleInputChange = event => {
        const {name, value} = event.target;
        setBillet(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    useEffect(() => {
        setLoading(true);
        api.get('/billets/' + user.document)
            .then((response) => setBillet(response.data))
            .catch((err) => {
                setAlertMessage('Erro ao buscar dados. Por favor tente novamente mais tarde');
                setShowAlert(true)
                console.error(err);
            }).finally(() => setLoading(false));
    }, [user.document]);

    return (
        <>
            <div className="pt-10 flex px-10 justify-between">
                <div className="text-blue-500 font-semibold">
                    <div className="flex">
                        <button onClick={() => {
                            navigate(-1);
                        }} className='group'>
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mb-3" fill="none"
                                 viewBox="0 0 24 24"
                                 stroke="currentColor" strokeWidth={2}>
                                <path strokeLinecap="round" strokeLinejoin="round"
                                      d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"/>
                            </svg>
                            <Tooltip text='Voltar'/>
                        </button>
                        <h2 className="text-3xl mb-4">Boletos</h2>
                    </div>
                </div>
                <div className="h-2">
                    <Alert color="red" message={alertMessage} show={showAlert} alertOpen={setShowAlert}/>
                    <Spinner loading={loading}/>
                </div>
                <div/>
            </div>
            <div className="mt-10 sm:mt-0 max-w-screen-lg flex flex-col">
                <div className="md:grid md:grid-cols-3 md:gap-6">
                    <div className="sm:pl-10 py-0 mt-5 md:mt-0 md:col-span-2">
                        <div className="shadow overflow-hidden shadow-xl border-gray-200 border-2 rounded-md">
                            <div className="px-4 py-5 sm:p-6">
                                <div className="grid grid-cols-6 gap-6">
                                    {inputsNoRepeat.map((input) => (
                                        <div key={input.name} className="col-span-6 sm:col-span-3">
                                            <Input
                                                id={input.name}
                                                type="text"
                                                label={input.label}
                                                value={billet[0] ? billet[0][input.name] : ''}
                                                disabled={true}
                                                required={false}
                                                name={input.name}
                                                handleChange={handleInputChange}
                                                // autoComplete={`billet.${billet[0][input.name] ?? ''}`}
                                            />
                                        </div>
                                    ))}
                                    {
                                        billet.map((item) => {
                                            return (
                                                <>
                                                    <div className="col-span-6" aria-hidden="true">
                                                        <div className="py-5">
                                                            <div className="border-t border-blue-400"/>
                                                        </div>
                                                    </div>
                                                    {inputs.map((input) => {
                                                        return (
                                                            <div key={input.name} className="col-span-6 sm:col-span-3">
                                                                <Input
                                                                    id={input.name}
                                                                    type="text"
                                                                    label={input.label}
                                                                    value={input.name !== 'valor' ? (item[input.name] ?? '') : (item[input.name] ?? 0).toLocaleString('pt-BR', {
                                                                        style: 'currency',
                                                                        currency: 'BRL'
                                                                    })}
                                                                    disabled={true}
                                                                    required={false}
                                                                    name={input.name}
                                                                    handleChange={handleInputChange}
                                                                    autoComplete={`billet.${item[input.name] ?? ''}`}
                                                                />
                                                            </div>);
                                                    })}
                                                </>);
                                        })}
                                </div>
                            </div>
                        </div>
                        <div className="text-center m-auto mt-5 w-3/4 max-w-xs ">
                            <Alert
                                show={showAlert}
                                alertOpen={setShowAlert}
                                color="red"
                                message={alertMessage}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}